/* eslint-disable no-param-reassign */
// this handler updates inboxApi redux store which uses ImmerJS and should allow param re-assign
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { inboxApi } from 'src/services/api/inboxApi';
import { FileNotification } from 'src/store/notifications/types';

interface InboxFileNotifications extends FileNotification {
  defaultListIndexPkey: string;
}

const INBOX_NOTIFICATION = 'INBOX_NOTIFICATION';

export const insertInboxNotifications = (
  notifications: InboxFileNotifications[],
) => async (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  // updating the inbox notifications list

  dispatch(
    inboxApi.util.updateQueryData('getInboxNotifications', undefined, draft =>
      notifications.forEach(n => {
        // don't do anything if its a draft notification
        if (n.ownerId.includes('DRAFT')) {
          return;
        }
        if (n.defaultListIndexPkey.includes(INBOX_NOTIFICATION)) {
          // if notification already exist then update the notification
          const existingNotificationIndex = draft.findIndex(d => d.id === n.id);
          if (existingNotificationIndex >= 0) {
            draft[existingNotificationIndex] = {
              ...n,
              fields: { ...n.fields, channelId: n.fields.channelId || '' },
              data: n.ownerId,
              createdAt: n.createdDate,
            };
            return;
          }

          // insert new notification
          draft.push({
            ...n,
            fields: {
              ...n.fields,
              channelId: n.fields.channelId || '',
            },
            data: n.ownerId,
            createdAt: n.createdDate,
          });
        }
      }),
    ),
  );
};
